import Translate from '../../i18n/Translate';

//Intersection
import { useInView } from 'react-intersection-observer'

const ItineraryList = ({ title, list }) => {

    const [item, inView] = useInView({
        triggerOnce: true,
        threshold: 0.2,
    })

    return (
        <div className={`itinerary-list animate slide-up ${inView ? 'in-view' : ''}`} ref={item}>
            <h3 className="list-title">{title}</h3>
            <ul className="list">
                {list.map((li, i) => {
                    return <li key={i}><Translate langkey={`${li}`} /></li>
                })}
            </ul>
        </div>
    )
}

export default ItineraryList